import Phaser from 'phaser';
import { saveStudentAstronaut, ProgressData as PlayerData } from '../systems/ProgressData';
import { mountMenu, element, button, header, go } from '../util/menuUI';
import { AVATAR_CATALOG } from '../avatar/AvatarCatalog';

// Identidad guest: el avatar avanzado y el progreso siguen guardados.
export class ProfileScene extends Phaser.Scene {
  constructor() { super('ProfileScene'); }

  create({ source = 'home' } = {}) {
    const root = mountMenu(this, 'tmag-profile-screen tmag-simple-profile');
    const student = this.registry.get('studentIdentity');
    const profile = PlayerData.getProfile();
    const isNew = !PlayerData.hasProfile();
    const fromGalaxy = source === 'galaxy';
    header(root, student ? 'ELIGE TU PERSONAJE' : isNew ? 'TU AVENTURA COMIENZA AQUÍ' : 'MI PERFIL',
      student ? student.alias : '¿Cómo quieres que te llamemos?', student ? null : fromGalaxy ? '← GALAXIA' : '← INICIO',
      student ? null : () => go(this, fromGalaxy ? 'GalaxyScene' : 'MenuScene'));
    if (student) { const slot = element('div', 'tmag-student-identity-slot'); slot.dataset.studentId = student.student_id; root.append(slot); }
    let current = true;
    this.events.once('shutdown', () => { current = false; });
    this.events.once('destroy', () => { current = false; });

    const form = element('form', 'tmag-simple-profile-form');
    const label = element('label', 'tmag-profile-label', 'APODO');
    const nickname = element('input', 'tmag-profile-input');
    nickname.type = 'text';
    nickname.name = 'nickname';
    nickname.maxLength = 18;
    nickname.autocomplete = 'nickname';
    nickname.placeholder = 'Ej. Luna Matemática';
    nickname.value = profile.nickname === 'Explorador/a' ? '' : profile.nickname;
    label.append(nickname);
    if (!student) form.append(label);

    const characters = element('fieldset', 'tmag-profile-characters');
    characters.append(element('legend', '', 'ELIGE TU PERSONAJE'));
    const choices = element('div', 'tmag-profile-character-grid');
    AVATAR_CATALOG.bases.forEach(base => {
      const card = element('label', 'tmag-profile-character');
      const choice = element('input', 'tmag-profile-character-radio');
      choice.type = 'radio';
      choice.name = 'explorer';
      choice.value = base.id;
      choice.checked = !student && profile.explorer === base.id;
      choice.required = true;
      const image = element('img', 'tmag-profile-character-image');
      image.src = base.portraitAsset;
      image.alt = ''; // El nombre de la tarjeta etiqueta también el control.
      card.append(choice, image, element('span', 'tmag-profile-character-name', base.label));
      choices.append(card);
    });
    characters.append(choices);
    form.append(characters);

    const save = button(student ? 'EMPEZAR A JUGAR' : fromGalaxy ? 'GUARDAR CAMBIOS' : isNew ? 'EMPEZAR A JUGAR' : 'CONTINUAR', () => {},
      'tmag-button tmag-primary tmag-profile-save');
    save.type = 'submit';
    form.append(save);
    let busy = false;
    const feedback = element('p', 'tmag-detail');
    feedback.setAttribute('role', 'alert');
    feedback.style.display = 'none';
    if (student) form.append(feedback);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !current) return;
      const explorer = form.querySelector('input[name="explorer"]:checked')?.value;
      if (!explorer) return;
      if (student) {
        busy = true; feedback.textContent = ''; feedback.style.display = 'none';
        form.querySelectorAll('input,button').forEach(node => { node.disabled = true; });
        save.textContent = 'Guardando…';
        try {
          const response = await saveStudentAstronaut(student.student_id, explorer);
          if (!current || this.registry.get('studentIdentity')?.student_id !== student.student_id) return;
          this.registry.set('studentIdentity', { ...student, avatar: response.avatar });
          go(this, 'MenuScene');
        } catch {
          if (current) { feedback.textContent = 'No pudimos guardar tu astronauta. Vuelve a intentar.'; feedback.style.display = ''; }
        } finally {
          if (current) { busy = false; save.textContent = 'EMPEZAR A JUGAR'; form.querySelectorAll('input,button').forEach(node => { node.disabled = false; }); }
        }
        return;
      }
      PlayerData.saveProfile({ nickname: nickname.value, explorer });
      go(this, fromGalaxy ? 'GalaxyScene' : 'GameModeScene');
    });
    root.append(form);
  }
}
